import AuthContainer from "./components/AuthContainer";

const HomePage = () => {
  // TODO-later add about details to the home page
  return <div className="flex justify-center items-center max-w-xs w-full"><AuthContainer /></div>;
};

export default HomePage;
